import { render, staticRenderFns } from "./LivingDonorMedicalHistory.vue?vue&type=template&id=5475d27e"
import script from "./LivingDonorMedicalHistory.vue?vue&type=script&lang=ts"
export * from "./LivingDonorMedicalHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports